import {
  GET_FINAL_BENEFICIARIES_AFFIDAVIT,
  GET_FINAL_BENEFICIARIES_AFFIDAVIT_ERROR,
  GET_FINAL_BENEFICIARIES_AFFIDAVIT_SUCCESS
} from './FinalBeneficiarySection.actions'

const FinalBeneficiarySectionState = {
  beneficiaries: [],
  error: null,
  hasAffidavit: false,
  isForcedAffidavit: false,
  loading: true
}

/**
 * The FinalBeneficiary grid section's reducer.
 */
const FinalBeneficiarySectionReducer = (state = FinalBeneficiarySectionState, { payload, type }) => {
  switch (type) {
    case GET_FINAL_BENEFICIARIES_AFFIDAVIT: {
      return {
        ...state,
        loading: true
      }
    }
    case GET_FINAL_BENEFICIARIES_AFFIDAVIT_ERROR: {
      return {
        ...state,
        error: payload.error,
        loading: false
      }
    }
    case GET_FINAL_BENEFICIARIES_AFFIDAVIT_SUCCESS: {
      return {
        ...state,
        beneficiaries: payload.beneficiaries,
        hasAffidavit: payload.hasAffidavit,
        isForcedAffidavit: payload.isForcedAffidavit,
        loading: false
      }
    }
    default: {
      return state
    }
  }
}

export default FinalBeneficiarySectionReducer
